module.exports = require("core-js/library/fn/object/assign");


//////////////////
// WEBPACK FOOTER
// /Users/akshetpandey/workspace/thriller-server/~/@babel/runtime/core-js/object/assign.js
// module id = 569
// module chunks = 168707334958949